require('./dist/dialogs.js');
require('./dist/dialogs-default-translations.js');
require('./dist/dialogs.css');
module.exports = 'dialogs.main';



//////////////////
// WEBPACK FOOTER
// ./~/angular-dialog-service/index.js
// module id = 768
// module chunks = 0